"use client"

import { Suspense } from "react"
import Link from "next/link"
import { ArrowLeft, ArrowRight, Trophy } from "lucide-react"
import { LeaderboardTable } from "@/components/community/leaderboard-table"
import { Button } from "@/components/ui/button"

export function LeaderboardPageContent() {
  return (
    <div className="min-h-screen bg-[#f4f1e8] py-6 md:py-12">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb */}
        <Link
          href="/community"
          className="mb-6 inline-flex min-h-11 items-center gap-1.5 text-sm font-semibold text-green-950/70 hover:text-green-700"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Community
        </Link>

        <header className="mb-8 overflow-hidden rounded-[2rem] bg-green-950 text-white md:mb-10">
          <div className="grid items-end gap-7 p-6 sm:p-8 md:grid-cols-[1fr_auto] md:p-10">
            <div>
              <div className="flex items-center gap-2 text-amber-300">
                <Trophy className="h-5 w-5" aria-hidden="true" />
                <p className="text-xs font-bold uppercase tracking-[0.14em]">The lawn board</p>
              </div>
              <h1 className="font-editorial mt-4 text-5xl font-semibold leading-none sm:text-6xl">
                Every vote moves the board.
              </h1>
              <p className="mt-4 max-w-2xl text-sm leading-6 text-green-50/75 sm:text-base">
                This all-time ranking is based only on community upvotes and downvotes. Weekly and regional boards will open once there are enough lawns for a useful competition.
              </p>
            </div>
            <Button asChild size="lg" className="min-h-12 rounded-full bg-white px-6 text-green-950 hover:bg-green-50">
              <Link href="/community/submit">
                Put your lawn on the board
                <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
              </Link>
            </Button>
          </div>
        </header>

        <div className="mb-4 flex items-end justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-green-700">All time</p>
            <h2 className="font-editorial mt-1 text-3xl font-semibold text-green-950">Current standings</h2>
          </div>
          <p className="hidden text-sm text-green-950/55 sm:block">Scores update as votes are cast.</p>
        </div>

        <Suspense fallback={<div className="ds-glass h-96 animate-pulse rounded-3xl" />}>
          <LeaderboardTable period="all-time" />
        </Suspense>
      </div>
    </div>
  )
}



